import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { identity } from '../../../../tornado/utils/sizes';
import { makeDefaultStylingContext } from '../../../../tornado/utils/style';
import { getInitialHeight } from '../../../../tornado/radio/radio.style';

export const defaultContext = makeDefaultStylingContext();

export { getInitialHeight } from '../../../../tornado/radio/radio.style';

export const TITLE_MARGIN_BOTTOM = {
  [HD]: 12,
  [FULL_HD]: 16,
};

export const PADDING_LEFT = {
  [HD]: 80,
  [FULL_HD]: 104,
};

export const colors = {
  background: makeThemeColor(PRIMARY, 0.3),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    h: getInitialHeight(screenSize),
    Background: {
      w: identity,
      h: identity,
      color: colors.background[colorMode],
      alpha: 0,
    },
    Radio: {
      x: PADDING_LEFT[screenSize],
    },
  };
};

export const unFocusedStyle = {
  Background: {
    smooth: {
      alpha: 0,
    },
  },
};

export const focusedStyle = {
  Background: {
    smooth: {
      alpha: 1,
    },
  },
};
